import { ProgressBarStyle, RtlLayout } from '@bakerweb/layouts';
import 'react-toastify/dist/ReactToastify.css';
import { GlobalStyles, ThemeConfig, ThemePrimaryColor } from '@bakerweb/theme';
import { ToastContainer } from 'react-toastify';

import Router from '../routes';

export const App: React.FC = () => {
  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <RtlLayout>
          <GlobalStyles />
          <ProgressBarStyle />
          <Router />
        </RtlLayout>
      </ThemePrimaryColor>
      <ToastContainer
        position="bottom-center"
        theme="dark"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
      />
    </ThemeConfig>
  );
};
